import { FolderOpen, TrendingUp, Briefcase, Calendar } from 'lucide-react'
import { StatsCardSkeleton } from '../LoadingSkeleton'

export default function ProjectStatsCards({ projects, userInfo, authUserCreatedAt, userLoading, loadingProjects }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {userLoading || loadingProjects ? (
        <>
          <StatsCardSkeleton />
          <StatsCardSkeleton />
          <StatsCardSkeleton />
          <StatsCardSkeleton />
        </>
      ) : (
        <>
          {/* Total Projects */}
          <div className="group relative backdrop-blur-xl bg-white/70 rounded-2xl shadow-lg border border-white/40 p-6 hover:shadow-2xl transition-all duration-300 overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-blue-500/5 opacity-0 group-hover:opacity-100 transition-opacity"></div>
            <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-blue-400 to-blue-400 rounded-l-2xl"></div>
            <div className="relative flex items-center justify-between">
              <div>
                <p className="text-slate-500 text-sm font-medium">Total Projects</p>
                <p className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-blue-600 bg-clip-text text-transparent mt-1">{projects.length}</p>
              </div>
              <div className="bg-gradient-to-br from-blue-100 to-blue-100 p-3 rounded-xl group-hover:scale-110 transition-transform duration-300">
                <FolderOpen className="w-8 h-8 text-blue-600" />
              </div>
            </div>
          </div>

          {/* Active This Month */}
          <div className="group relative backdrop-blur-xl bg-white/70 rounded-2xl shadow-lg border border-white/40 p-6 hover:shadow-2xl transition-all duration-300 overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-green-500/5 to-emerald-500/5 opacity-0 group-hover:opacity-100 transition-opacity"></div>
            <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-green-400 to-emerald-400 rounded-l-2xl"></div>
            <div className="relative flex items-center justify-between">
              <div>
                <p className="text-slate-500 text-sm font-medium">Active This Month</p>
                <p className="text-3xl font-bold bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent mt-1">
                  {projects.filter(p => {
                    const now = new Date()
                    const currentYear = now.getFullYear()
                    const currentMonth = now.getMonth()
                    const monthStart = new Date(currentYear, currentMonth, 1)
                    const monthEnd = new Date(currentYear, currentMonth + 1, 0, 23, 59, 59)
                    const projectStart = new Date(p.start_date)
                    const projectEnd = new Date(p.end_date)
                    return projectStart <= monthEnd && projectEnd >= monthStart
                  }).length}
                </p>
                <p className="text-xs text-slate-400 mt-1">Projects running now</p>
              </div>
              <div className="bg-gradient-to-br from-green-100 to-emerald-100 p-3 rounded-xl group-hover:scale-110 transition-transform duration-300">
                <TrendingUp className="w-8 h-8 text-green-600" />
              </div>
            </div>
          </div>

          {/* Your Role */}
          <div className="group relative backdrop-blur-xl bg-white/70 rounded-2xl shadow-lg border border-white/40 p-6 hover:shadow-2xl transition-all duration-300 overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-pink-500/5 opacity-0 group-hover:opacity-100 transition-opacity"></div>
            <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-blue-400 to-pink-400 rounded-l-2xl"></div>
            <div className="relative flex items-center justify-between">
              <div>
                <p className="text-slate-500 text-sm font-medium">Your Role</p>
                <p className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-pink-600 bg-clip-text text-transparent mt-1 capitalize">{userInfo?.role || 'User'}</p>
              </div>
              <div className="bg-gradient-to-br from-blue-100 to-pink-100 p-3 rounded-xl group-hover:scale-110 transition-transform duration-300">
                <Briefcase className="w-8 h-8 text-blue-600" />
              </div>
            </div>
          </div>

          {/* Member Since */}
          <div className="group relative backdrop-blur-xl bg-white/70 rounded-2xl shadow-lg border border-white/40 p-6 hover:shadow-2xl transition-all duration-300 overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-orange-500/5 to-amber-500/5 opacity-0 group-hover:opacity-100 transition-opacity"></div>
            <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-orange-400 to-amber-400 rounded-l-2xl"></div>
            <div className="relative flex items-center justify-between">
              <div>
                <p className="text-slate-500 text-sm font-medium">Member Since</p>
                <p className="text-lg font-bold bg-gradient-to-r from-orange-600 to-amber-600 bg-clip-text text-transparent mt-1">
                  {(userInfo?.created_at || authUserCreatedAt)
                    ? new Date(userInfo?.created_at || authUserCreatedAt).toLocaleDateString('id-ID', { month: 'short', year: 'numeric' })
                    : '-'}
                </p>
              </div>
              <div className="bg-gradient-to-br from-orange-100 to-amber-100 p-3 rounded-xl group-hover:scale-110 transition-transform duration-300">
                <Calendar className="w-8 h-8 text-orange-600" />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
